/* global axios */

import ApiClient from './ApiClient';

const botPersonasClient = new ApiClient('bot_personas', {
  accountScoped: true,
});

export const botPersonasAPI = {
  list() {
    return axios.get(botPersonasClient.url);
  },

  get(id) {
    return axios.get(`${botPersonasClient.url}/${id}`);
  },

  create(data) {
    return axios.post(botPersonasClient.url, { bot_persona: data });
  },

  update(id, data) {
    return axios.put(`${botPersonasClient.url}/${id}`, { bot_persona: data });
  },

  delete(id) {
    return axios.delete(`${botPersonasClient.url}/${id}`);
  },

  testInbox(id) {
    return axios.post(`${botPersonasClient.url}/${id}/test_inbox`);
  },
};

export const personaAiInstructionsAPI = {
  list(personaId) {
    return axios.get(
      `${botPersonasClient.url}/${personaId}/persona_ai_instructions`
    );
  },
  create(personaId, data) {
    return axios.post(
      `${botPersonasClient.url}/${personaId}/persona_ai_instructions`,
      { persona_ai_instruction: data }
    );
  },
  update(personaId, id, data) {
    return axios.put(
      `${botPersonasClient.url}/${personaId}/persona_ai_instructions/${id}`,
      { persona_ai_instruction: data }
    );
  },
  delete(personaId, id) {
    return axios.delete(
      `${botPersonasClient.url}/${personaId}/persona_ai_instructions/${id}`
    );
  },
};

export const personaTopicExpertisesAPI = {
  list(personaId) {
    return axios.get(
      `${botPersonasClient.url}/${personaId}/persona_topic_expertises`
    );
  },
  create(personaId, data) {
    return axios.post(
      `${botPersonasClient.url}/${personaId}/persona_topic_expertises`,
      { persona_topic_expertise: data }
    );
  },
  update(personaId, id, data) {
    return axios.put(
      `${botPersonasClient.url}/${personaId}/persona_topic_expertises/${id}`,
      { persona_topic_expertise: data }
    );
  },
  delete(personaId, id) {
    return axios.delete(
      `${botPersonasClient.url}/${personaId}/persona_topic_expertises/${id}`
    );
  },
};

export const personaPhraseLibrariesAPI = {
  list(personaId) {
    return axios.get(
      `${botPersonasClient.url}/${personaId}/persona_phrase_libraries`
    );
  },
  create(personaId, data) {
    return axios.post(
      `${botPersonasClient.url}/${personaId}/persona_phrase_libraries`,
      { persona_phrase_library: data }
    );
  },
  update(personaId, id, data) {
    return axios.put(
      `${botPersonasClient.url}/${personaId}/persona_phrase_libraries/${id}`,
      { persona_phrase_library: data }
    );
  },
  delete(personaId, id) {
    return axios.delete(
      `${botPersonasClient.url}/${personaId}/persona_phrase_libraries/${id}`
    );
  },
};

export const personaKbEntriesAPI = {
  list(personaId) {
    return axios.get(
      `${botPersonasClient.url}/${personaId}/persona_kb_entries`
    );
  },
  create(personaId, data) {
    return axios.post(
      `${botPersonasClient.url}/${personaId}/persona_kb_entries`,
      { persona_kb_entry: data }
    );
  },
  update(personaId, id, data) {
    return axios.put(
      `${botPersonasClient.url}/${personaId}/persona_kb_entries/${id}`,
      { persona_kb_entry: data }
    );
  },
  delete(personaId, id) {
    return axios.delete(
      `${botPersonasClient.url}/${personaId}/persona_kb_entries/${id}`
    );
  },
};

export const inboxBotSettingsAPI = {
  get(inboxId) {
    const client = new ApiClient(`inboxes/${inboxId}/inbox_bot_setting`, {
      accountScoped: true,
    });
    return axios.get(client.url);
  },

  update(inboxId, data) {
    const client = new ApiClient(`inboxes/${inboxId}/inbox_bot_setting`, {
      accountScoped: true,
    });
    return axios.patch(client.url, { inbox_bot_setting: data });
  },
};

export const conversationBotSettingsAPI = {
  get(conversationId) {
    const client = new ApiClient(
      `conversations/${conversationId}/conversation_bot_setting`,
      { accountScoped: true }
    );
    return axios.get(client.url);
  },

  update(conversationId, data) {
    const client = new ApiClient(
      `conversations/${conversationId}/conversation_bot_setting`,
      { accountScoped: true }
    );
    return axios.patch(client.url, { conversation_bot_setting: data });
  },
};
